import { EventTypes } from 'redux-segment';

import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';
import isTempTag from 'utils/predicates/isTempTag.util';

import { SAVE_SALON_TAG_FAILURE, SAVE_SALON_TAG_REQUEST, SAVE_SALON_TAG_SUCCESS } from './saveSalonTag.types';

const ATAG = 'saveSalonTag';
const L = logger(ATAG);

const saveSalonTag = L.wrap('()', (options) => {
  const { salonId, savedTag } = asObject(options);
  const isNewTag = isTempTag(savedTag.id);

  const processedTag = Object.assign(
    // FIXME: don't copy properties from one new object to another new object
    {},
    {
      name: savedTag.name,
      salon_id: savedTag.salonId,
      emoticon: savedTag.emoticon,
      ...{ id: isNewTag ? void 1 : savedTag.id },
      ...{ description: savedTag.description || void 1 },
    },
  );

  return {
    ATAG,
    [AUTH_API]: {
      ...authenticatedEndpoint(),
      ...(isNewTag
        ? jsonEndpoint(H.post, `salon/v2/${salonId}/client_tags/`, processedTag)
        : jsonEndpoint(H.put, `salon/v2/${salonId}/client_tags/${savedTag.id}/`, processedTag)),
      types: [SAVE_SALON_TAG_REQUEST, SAVE_SALON_TAG_SUCCESS, SAVE_SALON_TAG_FAILURE],
      params: { savedTagId: savedTag.id },
      meta: { analytics: EventTypes.track },
    },
  };
});

// noinspection JSUnusedGlobalSymbols
export default saveSalonTag;
